var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.navFunction.active !== 'blog-post')?_c('div',{staticClass:"card-inner",class:_vm.navFunction.active === _vm.sectionName
      ? `animated active ${_vm.width ? _vm.animationFunction.animationIn : ''}`
      : _vm.width
      ? `animated hidden ${_vm.width ? _vm.animationFunction.animationOut : ''}`
      : '',attrs:{"id":_vm.sectionName}},[_c('div',{staticClass:"card-wrap"},[_vm._t("default")],2)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }